import React from 'react';
import { useI18nContext } from '@ecg-marktplaats/js-react-i18n';
import { Button, ButtonsBlock } from '@hz-design-system/web-ui';

import trackEvent from '../../../utils/trackEvent';
import { BUNDLE_FREE_HOW_PROFILE } from '../../../constants/events';

import Classes from './BundleHero.scss';

type BundleHeroProps = {
  isPending: boolean;
  onCtaClick: (...args: any[]) => void;
};

const BundleHero = ({ isPending, onCtaClick }: BundleHeroProps) => {
  const i18n = useI18nContext();

  return (
    <div>
      <div className={Classes.root}>
        <h1 className={Classes.heading}>
          <span>{i18n.t('landingFreeBundle.hero.title.line1')}</span>
          <span className="BundleHero-highlighted">{i18n.t('landingFreeBundle.hero.title.line2')}</span>
        </h1>
        <div className={Classes.body}>{i18n.t('landingFreeBundle.hero.description')}</div>
        <ButtonsBlock kind="adaptive">
          <Button.Secondary
            as="a"
            href="#selling-points"
            onClick={() => trackEvent({ eventAction: BUNDLE_FREE_HOW_PROFILE })}
          >
            {i18n.t('landingFreeBundle.buttons.how')}
          </Button.Secondary>
          <Button.Primary onClick={onCtaClick} disabled={isPending}>
            {i18n.t('landingFreeBundle.buttons.cta')}
          </Button.Primary>
        </ButtonsBlock>
      </div>
    </div>
  );
};

export default BundleHero;
